import React, { useState, useReducer, useEffect } from 'react';
import { 
 ReferencesContainer,
 ReferencesWrapper,
 ReferencesHeader,
 ReferencesHeaderTitle,
 ReferencesHeaderArea,
 ReferencesContent,
} from './styles';
import colors from '../../assets/styles/colors';
import { H4, P } from '../../components/Typography/styles';
import { referencesSteps, personalRelationShip, familyRelationShip } from '../../helpers/enum';
import INITIAL_STATE_REFERENCES from '../../store/References/state';
import referencesReducer from '../../store/References';
import { ReferencesContext } from '../../store';
import FormSteps from '../../components/FormSteps';
import Copyright from '../../components/Copyright';
import Loader from '../../components/Loader';
import { useHistory, useLocation } from 'react-router-dom';
import { getCreditById } from '../../services/credit';
import { default as ReferencesTypes } from '../../store/References/types';
import { getSolicitationById } from '../../services/solicitations';
import { getReferences } from '../../services/references';
import PersonalReferencesPage from './Personal';
import FamilyReferencesPage from './Family';

const ReferencesPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [references, setReferences] = useReducer(referencesReducer, INITIAL_STATE_REFERENCES);
  const [activeStep, setActiveStep] = useState(referencesSteps.PERSONAL);
  const [lastStep, setLastStep] = useState(referencesSteps.DEFAULT);
  const [isLoading, setIsLoading] = useState(true);

  async function initializeStateComponent() {
    try {
      const creditResponse = await getCreditById(location.idCredit);
      const solicitationResponse = await getSolicitationById(location.idCredit);
      const referencesResponse = creditResponse.data?.idCreditoOriginal ? await getReferences(creditResponse.data?.idCreditoOriginal) : [];

      setReferences({
        type: ReferencesTypes.SET_CREDIT,
        credit: creditResponse.data
      })

      setReferences({
        type: ReferencesTypes.SET_SOLICITATION,
        solicitation: solicitationResponse.data
      })

      const personalReferences = referencesResponse.data.filter(refe => refe.tipoReferencia === 'PERSONAL');
      const familiarReferences = referencesResponse.data.filter(refe => refe.tipoReferencia === 'FAMILIAR');
      setReferences({
        type: ReferencesTypes.SET_PERSONAL,
        personal: {
          ...references.personal,
          first: {
            ...references.personal.first,
            state: personalReferences[0]?.departamentoTrabajo || {id:'', nombre:''},
            city: personalReferences[0]?.ciudadTrabajo || {id:'', nombre:''},
            firstPrimerNombre: personalReferences[0]?.primerNombre,
            firstSegundoNombre: personalReferences[0]?.segundoNombre,
            firstPrimerApellido: personalReferences[0]?.primerApellido,
            firstSegundoApellido: personalReferences[0]?.segundoApellido,
            relationship: personalRelationShip.find(relation => relation.id === personalReferences[0]?.relacion),
            firstCelular: personalReferences[0]?.telefonoCelular
          },
          second: {
            ...references.personal.second,
            state: personalReferences[1]?.departamentoTrabajo || {id:'', nombre:''},
            city: personalReferences[1]?.ciudadTrabajo || {id:'', nombre:''},
            secondPrimerNombre: personalReferences[1]?.primerNombre,
            secondSegundoNombre: personalReferences[1]?.segundoNombre,
            secondPrimerApellido: personalReferences[1]?.primerApellido,
            secondSegundoApellido: personalReferences[1]?.segundoApellido,
            relationship: personalRelationShip.find(relation => relation.id === personalReferences[1]?.relacion),
            secondCelular: personalReferences[1]?.telefonoCelular
          }
        }
      });
      setReferences({
        type: ReferencesTypes.SET_FAMILY,
        family: {
          ...references.family,
          first: {
            ...references.family.first,
            state: familiarReferences[0]?.departamentoTrabajo || {id:'', nombre:''},
            city: familiarReferences[0]?.ciudadTrabajo || {id:'', nombre:''},
            firstPrimerNombre: familiarReferences[0]?.primerNombre,
            firstSegundoNombre: familiarReferences[0]?.segundoNombre,
            firstPrimerApellido: familiarReferences[0]?.primerApellido,
            firstSegundoApellido: familiarReferences[0]?.segundoApellido,
            relationship: familyRelationShip.find(relation => relation.id === familiarReferences[0]?.relacion),
            firstCelular: familiarReferences[0]?.telefonoCelular
          },
          second: {
            ...references.family.second,
            state: familiarReferences[1]?.departamentoTrabajo || {id:'', nombre:''},
            city: familiarReferences[1]?.ciudadTrabajo || {id:'', nombre:''},
            secondPrimerNombre: familiarReferences[1]?.primerNombre,
            secondSegundoNombre: familiarReferences[1]?.segundoNombre,
            secondPrimerApellido: familiarReferences[1]?.primerApellido,
            secondSegundoApellido: familiarReferences[1]?.segundoApellido,
            relationship: familyRelationShip.find(relation => relation.id === familiarReferences[1]?.relacion),
            secondCelular: familiarReferences[1]?.telefonoCelular
          }
        }
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  useEffect(() => {
    if(!location.idCredit) {
      return history.push('/admin/dashboard');
    }

    initializeStateComponent();
  }, [])

  return (
    <ReferencesContainer id="means-of-disbursement-page">
      <ReferencesWrapper>
        <ReferencesHeader>
          <ReferencesHeaderTitle>Clientes</ReferencesHeaderTitle>
          <ReferencesHeaderArea>
            <H4 color={colors.textPrimary}>Referencias</H4>
            <P bold color={colors.textPrimary}>
            {references.solicitation?.cliente.nombres} {references.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. {references.solicitation?.cliente.identificacion}
            </P>
          </ReferencesHeaderArea>
        </ReferencesHeader>
        {isLoading ? <Loader /> : (
        <ReferencesContent id="means-of-disbursement-steps">
          <FormSteps lastStep={lastStep} steps={[
            {number: referencesSteps.PERSONAL, label: 'Referencias personales'},
            {number: referencesSteps.FAMILY, label: 'Referencias familiares'}
          ]} />
          <ReferencesContext.Provider value={{ references, setReferences }}>
            {activeStep === referencesSteps.PERSONAL && (
              <PersonalReferencesPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
            )}

            {activeStep === referencesSteps.FAMILY && (
              <FamilyReferencesPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
            )}
          </ReferencesContext.Provider>
        </ReferencesContent>
        )}
      </ReferencesWrapper>
      <Copyright />
    </ReferencesContainer>
  )
}

export default ReferencesPage
